import { zExt } from "@redotech/redo-model/common/zod-util";
import { ExtendedWarrantySchema } from "@redotech/redo-model/extended-warranty";
import { z } from "zod";

export const getOrderRegistrationEligibility = {
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    canBeRegistered: z.boolean(),
    eligibleLineItemIds: z.array(z.string()),
    registrationsByLineItemId: z.record(z.string(), z.number()),
    productIdToCollectionTitles: z.record(z.string(), z.array(z.string())),
    existingExtendedWarranties: z.array(ExtendedWarrantySchema),
  }),
};
